import { userAuthorizationSettings } from './authorization.model'

export type Space = keyof typeof userAuthorizationSettings.mappings.spaces

export const supportedSpaces = Object.keys(userAuthorizationSettings.mappings.spaces) as Space[]

export const isSpace = (value: unknown): value is Space => {
  const space = value as Space

  return supportedSpaces.includes(space)
}
